import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import EditableCard from 'modules/common/editableCard.component';
import { getClientDetails, updateClient } from 'modules/clients/clients.actions';
import { showToast } from 'modules/layout/layout.actions';
import { UPDATE_CLIENT_FAILURE } from 'modules/clients/types';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { connect } from 'react-redux';

const SalesCard = (props) => {
  
  const { clientDetails, internalUsers, hideEdit = false } = props;

  const [isLoading, setIsLoading] = useState(false);

  const summaryTabs = [{ header: 'Sales', order: 1, iconPath: ['fas', 'chart-line'] }];
  const filteredInternalUsers = internalUsers?.map(user => ({ id: user.internalUserId, title: `${user.firstName} ${user.lastName}` })) || [];

  const fields = [
    { 
      header: 'Sales Representative', 
      accessorKey: 'salesRepresentativeId', 
      type: 'dropdown-v2', 
      options: filteredInternalUsers, 
      required: false, 
      value: clientDetails ? clientDetails.salesRepresentativeId : '', 
      tab: 1 
    },
    { 
      header: 'Projected Revenue', 
      accessorKey: 'projectedRevenue', 
      type: 'money', 
      required: false, 
      value: clientDetails ? clientDetails.projectedRevenue : '', 
      tab: 1 
    },
  ];

  const updateFields = async (tab, values) => {
      setIsLoading(true);
  
      let newVals = { ...clientDetails };
  
      newVals.salesRepresentativeId = values.salesRepresentativeId;
      newVals.projectedRevenue = values.projectedRevenue;

      const resp = await props.updateClient(newVals);
      if (resp.type === UPDATE_CLIENT_FAILURE) {
        props.showToast('Failed to update sales info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else {
        await props.getClientDetails(clientDetails.clientRecordId);
        props.showToast('Sales info updated successfully.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        setIsLoading(false);
        return true;
      }
  };

  return (
    <EditableCard tabs={summaryTabs} summaries={fields} numColumns={2} isLoading={isLoading} hideEdit={hideEdit} updateFields={updateFields} />
  );
};

SalesCard.propTypes = {
  clientDetails: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
  updateClient: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired,
  getClientDetails: PropTypes.func.isRequired,
};
  
export default compose(
  connect(null, {
    updateClient,
    showToast,
    getClientDetails
  })
)(SalesCard);
